import * as $ from 'jquery';
import * as kendo from 'kendo/kendo.core';
import SearchRepository from 'AWFWSK/Data/Repositories/SearchRepository';
import 'kendo/kendo.data';

export function create(options?: kendo.data.DataSourceOptions, relation?: any): kendo.data.DataSource {
    const repository = new SearchRepository();
    const dataSourceOptions: kendo.data.DataSourceOptions = {
        transport: {
            read: (kendoOptions: kendo.data.DataSourceTransportReadOptions) => {
                if (kendoOptions.data && kendoOptions.data.filter && kendoOptions.data.filter.filters.length > 0) {
                    const filter = kendoOptions.data.filter.filters[0];
                    const text = (filter as any).value;

                    if (text != null && text !== '') {
                        const suggestionsPromise = repository.suggest(text);
                        suggestionsPromise.then(suggestions => {
                            kendoOptions.success(suggestions);
                        });

                        suggestionsPromise.catch(e => {
                            kendoOptions.error(e);
                        });
                    } else {
                        kendoOptions.success([]); /* No filter defined => empty array */
                    }
                } else {
                    kendoOptions.success([]); /* No filter defined => empty array */
                }

            }
        },
        serverFiltering: true
    };

    return new kendo.data.DataSource($.extend(dataSourceOptions, options));
}